export default {
  16481: 'employee',
  16482: 'company',
  16513: 'organizer'
};
